export default __webpack_public_path__ + "static/media/logout_icon.e0321be5.svg";